import { render, staticRenderFns } from "./HomePageNoteComponent.vue?vue&type=template&id=8f04bc7a&scoped=true&"
import script from "./HomePageNoteComponent.vue?vue&type=script&lang=js&"
export * from "./HomePageNoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomePageNoteComponent.vue?vue&type=style&index=0&id=8f04bc7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f04bc7a",
  null
  
)

export default component.exports